<template>
  <div>
    <div :key="player._id" v-for="player in players">
      <CrystalShardOne v-if="player && isAlive({ player })" :player="player"></CrystalShardOne>
    </div>
  </div>
</template>

<script>
import * as THREE from 'three'
export default {
  props: {
    scene: {},
    camera: {},
    engine: {},
    players: {},
    cells: {},
    rootThreeDee: {}
  },
  components: {
    CrystalShardOne: require('./CrystalShardOne.vue').default
  },
  data () {
    return {
      obj3D: new THREE.Object3D()
    }
  },
  methods: {
    isAlive ({ player }) {
      return this.$parent.game.cells.some(e => e.uid === player.userID)
    }
  },
  created () {
    // .
    this.$on('add', (v) => {
      this.obj3D.add(v)
    })
    // .
    this.$on('remove', (v) => {
      this.obj3D.remove(v)
    })

    this.rootThreeDee.add(this.obj3D)
  }
}
</script>

<style>

</style>